export const getDecimalPlaces = (num: number): number => {
  const decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
};
